import ViewBase from "../../../../../framework/core/mvvm/view_base";
import ModelData, { PlayerIconData, IUserData } from "../../../../public/model_data";
import { ListViewDir, ListView } from "../../../../../framework/tools/scrollview/listview";
import LoaclStorage from "../../../../../manager/local_storage";
import CryptoJS = require("crypto-js");
import TextureManager from "../../../../../manager/texture_manager";
import Utility from "../../../../../utility/utility";
import ModuleManager from "../../../../../framework/core/module_manager";
import PublicPlayerAvatar from "../../../../public/component/public_player_avatar";
import UserDataManager from "../../../../../manager/user_manager";
import PromiseUtility from "../../../../../utility/promiseUtility";

const { ccclass, property } = cc._decorator;

export interface IIconData{
    spriteFrame?:cc.SpriteFrame;
    avatarUrl?:string;
}

//state 0 新增 1 更新 key -- ('all')
export type checkImageFunc = (state:number,key:string)=>void;

@ccclass
export class IconEditorView extends ViewBase {
    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;

    @property(cc.Node)
    viewNode: cc.Node = null;

    @property(cc.Node)
    content: cc.Node = null;

    @property(cc.Node)
    prefab: cc.Node = null;

    @property(cc.Node)
    select:cc.Node = null;

    @property(cc.Sprite)
    playerIcon: cc.Sprite = null;

    @property(cc.Node)
    photoNode:cc.Node = null;

    @property(cc.Node)
    cameraNode:cc.Node = null;

    @property(PublicPlayerAvatar)
    player_avatar:PublicPlayerAvatar = null;

    @property(cc.Label)
    playerId:cc.Label = null;

    private curSelect:cc.Node = null;

    protected selectData: IIconData = null;

    protected listView: ListView = null;
    protected maleIcons;
    protected femaleIcons;

    private curUrl:string = ''
    private curFrame:string = ''

    private isInit:boolean = false;

    private key1:string = '_out_Sprite_one';//自定义账号
    private key2:string = '_out_Sprite_two';//社交账号

    init(){
        this.listView = new ListView({
            scrollview: this.scrollView,
            view: this.viewNode,
            content: this.content,
            item_prefab: this.prefab,
            cb_host: this,
            item_update_func: this.update_list_item,
            item_click_ex_func: this.item_click_func,
            item_click_func:this.item_click_Node,
            column: 4,
            gap_y: 20,
            gap_x: 15,
            direction: ListViewDir.Vertical,
        });
    }

    onShow(arg0)
    {
        super.onShow(arg0)
        this.photoNode.active = CC_JSB;
        this.cameraNode.active = CC_JSB;
        this.refreshGenderIcons();
        if (!this.isPlayerInfoActive()) {
            this.resetIconPanelData();
        }
    }

    refreshGenderIcons(){

        let roleData = ModelData.instance.roleData;
        let localGender = LoaclStorage.getNumber('_player_gender_'+roleData.id,0);

        if (localGender == 0) {
            localGender = roleData.gender;
        }

        [this.maleIcons, this.femaleIcons]= ModelData.instance.getPlayerIcons();
        let playerIcons = localGender==1?this.maleIcons:this.femaleIcons
        let icons:IIconData[] = [];
        for (let index = 0; index < playerIcons.length; index++) {
            let data = playerIcons[index];
            icons.push({
                spriteFrame:data.iconRes,
                avatarUrl:data.iconName,
            })
        }
        this.updateHeadFrame();
        this.listView.set_data(icons)
        this.clickAvatarUrl(this.url)

        if (!this.isHaveSameUrl(ModelData.instance.roleData.avatar)) {
            this.checkSaveLocalImage(ModelData.instance.roleData.avatar)
        }

        let func1 = (cb)=>{
            this.refreshIconList(false,this.key2,false,cb);
        }
    
        let func2 = (cb)=>{
            this.refreshIconList(false,this.key1,false,cb);
        }

        PromiseUtility.sequence([func1,func2]).then(function () {

        })



    }

    //1.2.x.x.x.x. //处理key
    checkSaveLocalImage(url:string,func?:checkImageFunc){
        if (!url || url.length <= 0 || !this.isHttpAvatar(url)) {
            return;
        }

        let saveKey1 = this.getSaveKey(this.key1);
        let saveKey2 = this.getSaveKey(this.key2);

        let url1 = LoaclStorage.getString(saveKey1,'');
        let url2 =  LoaclStorage.getString(saveKey2,'');

        if (url2 && url2.length > 0) {//第二个槽有 必然第一个已经放满

            LoaclStorage.setString(saveKey2,url1);
            //更改第一个的
            this.saveLocalSprite(true,url,this.key1)
            func && func(1,'all');

        }else{
            if (!url1 || url1.length <= 0) {
                this.saveLocalSprite(true,url,this.key1);
                func && func(0,this.key1);
            }else{//第二个没有//需要进行替换
                LoaclStorage.setString(saveKey2,url1);
                this.saveLocalSprite(true,url,this.key1)
                func && func(1,'all');
            }
        }
    }
    

    //保存本地相片
    saveLocalSprite(isSave:boolean,url:string,usekey:string){
        let key = this.getSaveKey(usekey);
        if (!CC_JSB) {
            isSave && LoaclStorage.setString(key,url);
        }else{
            TextureManager.instance.downloadImageFromUrlToLocalPath(url, (path:string)=>{
                if (path.length > 0 && isSave) {
                    LoaclStorage.setString(key,url);
                }
            })
        }
    }

    getLocalSprite(usekey:string,func:Function){
        let key = this.getSaveKey(usekey)
        let url = LoaclStorage.getString(key,'');
        if (url && url.length > 0) {
            if (CC_JSB) {
                TextureManager.instance.tryGetSpriteFromDisk(url,(spriteFrame:cc.SpriteFrame)=>{
                    func && func(spriteFrame,url)
                })
            }else{
                UserDataManager.getAvatarSprite(url,(spriteFrame)=>{
                    this.nodeIsValid && func && func(spriteFrame,url)
                })
            }
        }else{
            func && func()
        }
    }


    //获取保存的key
    getSaveKey(key:string){
        let roleData = ModelData.instance.roleData;
        return roleData.id + key;
    }

    isHaveLocalImage(){

        let localUrl = (key)=>{
            let saveKey = this.getSaveKey(key)
            let url = LoaclStorage.getString(saveKey,'');
            return url
        }

        let url1 = localUrl(this.key1);
        let url2 = localUrl(this.key2);
        return (url1 && url1.length > 0) || (url2 && url2.length > 0)
    }

    refreshIconList(isrefresh:boolean,usekey:string,isNeedUpdate?:boolean,func?:Function){
        this.getLocalSprite(usekey,(sp:cc.SpriteFrame,url:string)=>{
            if (sp) {
                let data = {
                    spriteFrame:sp,
                    avatarUrl:url,
                }
                if (isrefresh) {
                    this.listView.refresh_item(usekey == this.key1 ? 0:1,data);
                }else{//新增
                    let item = this.listView.items[0];
                    if (item && item.data) {
                        if (item.data.avatarUrl != url) {
                            this.listView.insert_data(0,data)
                        }
                    }
                }
                
                this.clickAvatarUrl(isNeedUpdate?url:this.url)
            }
            func && func();
        })
    }

    beforUploadImage(curUrl:string){
        if (this.isHttpAvatar(curUrl)) {

            if (!this.isHaveSameUrl(curUrl)) {
                this.checkSaveLocalImage(curUrl);
            }
            this.curUrl = curUrl;
            this.refreshGenderIcons()
        }
    }

    getSelectData():string
    {
        if(this.selectData != null)
        {
            return this.selectData.avatarUrl
        }
        return '';
    }

    isPlayerInfoActive(){
        let module = ModuleManager.instance.moduleHasActive('PlayerInfoSetting')
        return module;
    }

    get url(){
        if (this.curUrl == '') {
            return ModelData.instance.roleData.avatar;
        }
        return this.curUrl;
    }

    get frameKey(){
        let m = ModuleManager.instance.getModule('PlayerInfoSetting')
        if (m.plizedTypeByCode['head_frame']) {
            return m.plizedTypeByCode['head_frame']
        }
        return ModelData.instance.roleData.plizedHeadFrame;
    }

    setAvatarUrl(url:string){
        if (this.isPlayerInfoActive()) {
            let m = ModuleManager.instance.getModule('PlayerInfoSetting')
            m.avatarUrl = url;
        }
    }

    updateHeadFrame(){
        this.player_avatar.loadAnimByKey(this.frameKey);
    }

    isHttpAvatar(url:string):boolean{
        if (url && url.indexOf("http") >= 0) {
            return true;
        }
        return false;
    }

    isHaveSameUrl(url:string){
        let funcSame = (outUrl:string,useKey:string)=>{
            let saveKey = this.getSaveKey(useKey);
            let url = LoaclStorage.getString(saveKey,'');
            return url && url.length > 0 && url == outUrl
        }
        return funcSame(url,this.key2) || funcSame(url,this.key1);
    }

    avatarSize():cc.Size{
        return this.playerIcon.node.getContentSize();
    }

    setSelectImage(texture:cc.Texture2D,data:any){
        let size = this.avatarSize();
        let frame = new cc.SpriteFrame(texture)
        frame.setOriginalSize(size)
        this.refreshPlayerIcon(frame);
        this.selectData = null;
    }

    refreshPlayerId(id:number){
        this.playerId.string = 'ID:'+id;
    }

    refreshPlayerIcon(spriteFrame: cc.SpriteFrame)
    {
        if (!spriteFrame) {
            return;
        }
        this.playerIcon.spriteFrame = spriteFrame;
    }

    resetIconPanelData(){
        this.selectData = null;
        this.curSelect = null;
        this.select.active = false;
        this.curUrl = ''
    }
    
    update_list_item(item: cc.Node, data: any, index: number): void {
        let iconData = <IIconData>data;
        let _icon = cc.find('avatar/Mask/icon',item);
        let icon = _icon.getComponent<cc.Sprite>(cc.Sprite);
        icon.spriteFrame = iconData.spriteFrame
    }

    item_click_func(data: any) {
        if (this.select.active) {
            this.selectData = <IIconData>data;
            this.curUrl = this.selectData.avatarUrl;
            this.setAvatarUrl(this.curUrl);
            if (this.selectData) {
                this.refreshPlayerIcon(this.selectData.spriteFrame);
            }
        }else{
            this.selectData = null;
        }
    }


    clickAvatarUrl(url:string){
        if (url && url.length > 0) {
            for (let i = 0; i < this.listView.items.length; i++) {
                const element = this.listView.items[i];
                if (element.data.avatarUrl == url) {
                    this.item_click_Node(element.node)
                    this.item_click_func(element.data);
                    return;
                }
            }
        }
    }



    item_click_Node(item:cc.Node){
        
        this.selectItem(item);

        if (this.curSelect) {
            if (this.curSelect == item) {
                //this.select.active = !this.select.active;
            }else{
                this.select.active = true;
            }
        }else{
            this.select.active = true;
        }
        this.curSelect = item;
    }

    selectItem(node:cc.Node){
        if (node) {
            this.select.parent = node;
            this.select.position = cc.Vec3.ZERO;
        }
    }
}
